import { ActionsUnion, createAction } from "../definitions";
import { DriverChangesActionTypes } from "./types";
import { IDriverChange } from "../../model/DriverChangeLog";

export interface IDriverChangePayload {
    userId: string;
    driverChanges: IDriverChange[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DriverChangesActions = {
    setDriverChanges: (payload: IDriverChangePayload) => createAction(DriverChangesActionTypes.SET_DRIVER_CHANGES, payload),
    clearDriverChanges: (payload: string) => createAction(DriverChangesActionTypes.CLEAR_DRIVER_CHANGES, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DriverChangeActions = ActionsUnion<typeof DriverChangesActions>;